import { Nav, Tab } from "react-bootstrap";
import { IChangeRequestDetails } from "../../../api/IChangeRequests";
import { ILicenceProfile } from "../../../api/LicenceProfile";
import { DocumentsGrid } from "../../../leap-components/Documents/DocumentsGrid";
import EpaCard from "../../../leap-components/EpaCard";

interface SubTabsProps {
  className?: string;
  activeKey: string;
  changeRequestDetails: IChangeRequestDetails;
  licenceProfile: ILicenceProfile;
}

interface FurtherInformationProps {
  changeRequestDetails: IChangeRequestDetails;
  licenceProfile: ILicenceProfile;
}

const SubTabs = ({
  className,
  activeKey,
  changeRequestDetails,
  licenceProfile,
}: SubTabsProps) => (
  <div className={"tab " + className}>
    <Tab.Container id="left-tabs-example" defaultActiveKey={activeKey}>
      <Nav variant="tabs">
        <Nav.Item>
          <Nav.Link eventKey="documents">Documents</Nav.Link>
        </Nav.Item>
      </Nav>
      <Tab.Content>
        <Tab.Pane eventKey="documents">
          <DocumentsGrid
            regardingObjectId={changeRequestDetails.licencechangerequestid}
          />
        </Tab.Pane>
      </Tab.Content>
    </Tab.Container>
  </div>
);

const FurtherInformation = ({
  changeRequestDetails,
  licenceProfile,
}: FurtherInformationProps) => {
  var bodyElements = (
    <SubTabs
      activeKey="documents"
      changeRequestDetails={changeRequestDetails}
      licenceProfile={licenceProfile}
    />
  );
  return <EpaCard title={"Further Information"} content={bodyElements} />;
};

export default FurtherInformation;
